import { useState, useEffect } from 'react';
import { useLocations as useUserLocations } from '../../../stores/User/user.queries';

/**
 * useLocations - lightweight hook to return only unique location ids and names.
 * Now uses the centralized useLocations hook from User store.
 */

export const useLocations = () => {
  const { data: locationsData, error: queryError, refetch: queryRefetch } = useUserLocations();
  const [error, setError] = useState<string | null>(null);

  // Transform the LocationDto[] to the format expected by BIDashboard components
  const locations = locationsData?.map(location => ({
    id: location.id!,
    name: location.name || location.id!
  })) || [];

  // Handle errors from React Query
  useEffect(() => {
    if (queryError) {
      setError('Failed to fetch locations');
    } else {
      setError(null);
    }
  }, [queryError]);

  const refetch = async () => {
    setError(null);
    try {
      await queryRefetch();
    } catch (err: any) {
      console.error('useLocations.refetch error', err?.message || err);
      setError(err?.message || 'Failed to refetch locations');
    }
  };

  return { locations, error, refetch };
};

export default useLocations;
